export default "__VITE_ASSET__CX0Vs$GV__"